import MyAccountMenuState from "@dana/Store/Data/MyAccountMenu/MyAccountMenuState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: MyAccountMenuState = {
    isOpen:false,
};

const myAccountMenuStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "MyAccountMenu/IsOpen": (draft: Draft<MyAccountMenuState>, action: { isOpen: boolean }) => {
        draft = { ...initialState, isOpen: action.isOpen };
        return draft;
    }, 
});

(reducers as any).myAccountMenuState = myAccountMenuStateImmerReducer;

type MyAccountMenuReducers = {
    myAccountMenuState: typeof myAccountMenuStateImmerReducer;
};

export type MyAccountMenuActions = Parameters<MyAccountMenuReducers[keyof MyAccountMenuReducers]>[1] | AnyAction;

